<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="otherOutboundVerification commonListStyles">
            <van-nav-bar left-arrow left-text="应用" :style="`height: ${ $getNavHeight() }px;`" @click-left="swiperright">
                <template #title>
                    <div :class="{'active': listType == 'db'}" @click="listSwitch('db')">
                        待审批
                    </div>
                    <div :class="{'active': listType == 'yb'}" @click="listSwitch('yb')">
                        已审批
                    </div>
                </template>
            </van-nav-bar>
            <section>
                <van-search v-model="keyVal" placeholder="请输入搜索信息" @change="onRefresh"></van-search>
                <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                    <van-list v-model="isUpLoading" finished-text="没有更多了!" :finished="finished" @load="onLoad">
                        <ul class="list">
                            <li class="listItem" v-for="(item,index) in listData" :key="`item_${index}`">
                                <div class="engineeringInfo">
                                    <h4 class="itemTitle">
                                        <span class="iconfont iconhetong">其他入库编号：{{ item.instock_number }}</span>
                                    </h4>
                                    <p class="itemStatus">
                                        {{ item.status_name }}
                                    </p>
                                    <div class="itemContent">
                                        <p>
                                            <img src="@/assets/images/icons/icon_8@2x.png" alt="">
                                            <span>申请人：{{ item.apply_user_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_7@2x.png" alt="">
                                            <span>申请时间：{{ item.apply_time }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_47@2x.png" alt="">
                                            <span>仓库名称：{{ item.stock_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_8@2x.png" alt="">
                                            <span>库管员：{{ item.storeman_name }}</span>
                                        </p>
                                    </div>
                                    <div class="itemBtn itemBtns">
                                        <button v-if="listType === 'db'" @click="openApprovalProcess(item)">
                                            审批
                                        </button>
                                        <button v-else @click="openApprovalProcess(item)">
                                            查看
                                        </button>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </van-list>
                </van-pull-refresh>
            </section>
        </div>
    </v-touch>
</template>

<script>
import { mixin_list } from '@/assets/mixin/mixin_list';
export default {
    name: 'other-outbound-verification',
    mixins: [mixin_list],
    components: {},
    beforeRouteLeave(to, from, next) {
        if (to.path !== '/approvalProcess') {
            this.$store.commit('noKeepAlive', 'other-outbound-verification');
        }
        next();
    },
    data() {
        return {
            listType: 'db',
            tableCode: 'other_outstock_dsp',
        };
    },
    watch: {},
    activated() {
        if (this.$route.params.isRefresh) {
            this.onRefresh();
        }
    },
    created() {
        this.cacheKey = Math.floor(Math.random() * 1000000000000 + 1);
    },
    mounted() {},
    computed: {},
    methods: {
        // 待办已办切换
        listSwitch(type) {
            if (type === 'db') {
                this.tableCode = 'other_outstock_dsp';
            } else if (type === 'yb') {
                this.tableCode = 'other_outstock_ysp';
            }
            this.pageIndex = 0;
            this.listData = [];
            this.listType = type;
            this.finished = false;
            this.initPage();
        },
        // 打开合同审批页
        openApprovalProcess(data) {
            data.BusinessInstanceId = data.business_instance_id;
            this.$router.isBack = 2;
            this.$router.push({
                name: 'approvalProcess',
                params: {
                    data: data,
                    isReadOnly: this.listType === 'db' ? false : true,
                },
            });
        },
    },
    updated() {},
    destroyed() {},
};
</script>

<style lang="stylus" scoped>
.otherOutboundVerification
    width 100%
    height 100%
    background #F0F0F0
    .van-nav-bar
        .van-nav-bar__title
            div
                display inline-block
                padding 0 15rpx
                font-size 14rpx
                color rgba(240,240,240,0.7)
                transition 0.2s
                &.active
                    font-size 18rpx
                    color #fff
</style>
